/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken } from "@services/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

interface FormSubmitApiBody {
    fields: { codeName: string; value: string }[];
    leadId: string | null;
    jornayaId: string | undefined;
    url?: string;
    submit: boolean;
    domainFormId: number | null;
    otpCode: string | undefined;
    language: string;
    fetchBuyers: boolean;
    buyerIds?: number[] | null | undefined;
    consentLanguage?: string | null;
    isOneToOneConsent?: boolean;
    meta?: {
        [x: string]: string;
    };
}
export interface SubmitLeadFormResponse {
    success: boolean;
    data: {
        leadId: string | null;
        operationId: string | null;
        otpRequired: boolean;
        otpTime: number | undefined;
        results?:
            | undefined
            | {
                  status: "rejected";
                  codeName: string;
                  reason: string;
              }[];
    } | null;
}

export const submitLeadForm = async (
    data: FormSubmitApiBody,
): Promise<{
    data: SubmitLeadFormResponse["data"] | null;
    error: Error | null;
}> => {
    const accessToken = getAccessToken();

    const {
        fields,
        leadId,
        jornayaId,
        url,
        submit,
        domainFormId,
        otpCode,
        language,
        meta,
        fetchBuyers,
        buyerIds,
        consentLanguage,
        isOneToOneConsent,
    } = data;

    const trustedFormCertificateUrl: string =
        //@ts-ignore
        document.getElementById("TrustedFormCertUrl_0")?.value;

    const config: AxiosRequestConfig = {
        method: "post",
        url: `/api/submitLeadForm`,
        data: {
            fields,
            leadId: leadId || undefined,
            jornayaId: jornayaId ? jornayaId : undefined,
            url: url ?? window.location.href,
            submit,
            fetchBuyers,
            buyerIds,
            consentLanguage,
            isOneToOneConsent,
            domainFormId: domainFormId || undefined,
            trustedFormCertificateUrl: trustedFormCertificateUrl
                ? trustedFormCertificateUrl
                : undefined,
            otpCode,
            language,
            meta,
        },
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
        },
    };

    const { data: submitLeadFormResponse, error } =
        await apiHandler<SubmitLeadFormResponse>(() => HTTP.client(config));

    return {
        data: submitLeadFormResponse?.data ?? null,
        error,
    };
};
